export default __webpack_public_path__ + "static/media/payment.a2c1774b.svg";